import React from 'react';
import PropTypes from 'prop-types';

import AlertDescription from '../AlertDescription';

import './AlertMiddleBlock.theme.scss';

export default function AlertMiddleBlock(props) {
  const { name, dbName, type } = props;

  return (
    <div className="alert-middle-block">
      {type === 'header' ? (
        <h3 className="alert-middle-block--name u-els-font-size-h4">
          {name} - in {dbName}
        </h3>
      ) : (
        <AlertDescription showLabel="Show details" hideLabel="Hide details" {...props} />
      )}
    </div>
  );
}

AlertMiddleBlock.propTypes = {
  name: PropTypes.string.isRequired,
  dbName: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
